<template>
  <div class="page-container">

    <CrmPageHeader
      title="Opciones"
      subtitle="Herramientas administrativas y sincronización de datos"
      icon="fas fa-cog"
    />

    <!-- Section: Sincronización -->
    <p class="section-label">Sincronización</p>
    <div class="options-grid mb-5">

      <!-- Domus -->
      <div class="opt-card" @click="runModalDomu">
        <div class="opt-card__icon" style="background:linear-gradient(135deg,#1E3A5F,#2563EB)">
          <i class="fas fa-building"></i>
        </div>
        <div class="opt-card__body">
          <p class="opt-card__title">Domus</p>
          <p class="opt-card__desc">Obtener inmuebles desde Domus y registrarlos en CRMRED</p>
        </div>
        <div class="opt-card__action">
          <span class="opt-badge opt-badge--blue">Sincronizar</span>
          <i class="fas fa-chevron-right opt-card__arrow"></i>
        </div>
      </div>

      <!-- Metrocuadrado -->
      <div class="opt-card" :class="{ 'opt-card--loading': isLoadingM }" @click="runAgentMetrocucadrado">
        <div class="opt-card__icon" style="background:linear-gradient(135deg,#0284C7,#0EA5E9)">
          <i class="fas fa-search-location"></i>
        </div>
        <div class="opt-card__body">
          <p class="opt-card__title">Metrocuadrado</p>
          <p class="opt-card__desc">Obtener códigos de agentes nuevos que se registran en el portal</p>
        </div>
        <div class="opt-card__action">
          <span v-if="isLoadingM" class="opt-badge opt-badge--gray">
            <i class="fas fa-spinner fa-spin me-1"></i>Ejecutando...
          </span>
          <span v-else class="opt-badge opt-badge--sky">Sincronizar</span>
          <i class="fas fa-chevron-right opt-card__arrow"></i>
        </div>
      </div>

      <!-- Wasi -->
      <div class="opt-card" @click="runModalWasi">
        <div class="opt-card__icon" style="background:linear-gradient(135deg,#B91C1C,#EF4444)">
          <i class="fas fa-plug"></i>
        </div>
        <div class="opt-card__body">
          <p class="opt-card__title">Wasi</p>
          <p class="opt-card__desc">Conectar la cuenta de Wasi e importar el inventario completo al CRM</p>
        </div>
        <div class="opt-card__action">
          <span class="opt-badge opt-badge--red">Integración</span>
          <i class="fas fa-chevron-right opt-card__arrow"></i>
        </div>
      </div>

      <!-- Apperty -->
      <div class="opt-card" @click="runModalApperty">
        <div class="opt-card__icon" style="background:linear-gradient(135deg,#0F766E,#14B8A6)">
          <i class="fas fa-exchange-alt"></i>
        </div>
        <div class="opt-card__body">
          <p class="opt-card__title">Apperty</p>
          <p class="opt-card__desc">Guardar el token de un usuario y migrar sus propiedades desde Apperty</p>
        </div>
        <div class="opt-card__action">
          <span class="opt-badge opt-badge--teal">Integración</span>
          <i class="fas fa-chevron-right opt-card__arrow"></i>
        </div>
      </div>

    </div>

    <!-- Section: Exportaciones -->
    <p class="section-label">Exportaciones</p>
    <div class="options-grid mb-5">

      <!-- Exportar Usuarios -->
      <div class="opt-card" :class="{ 'opt-card--loading': isLoadingU }" @click="exportUsersMembership">
        <div class="opt-card__icon" style="background:linear-gradient(135deg,#059669,#10B981)">
          <i class="fas fa-users"></i>
        </div>
        <div class="opt-card__body">
          <p class="opt-card__title">Exportar Usuarios</p>
          <p class="opt-card__desc">Exportar usuarios con sus membresías en formato Excel</p>
        </div>
        <div class="opt-card__action">
          <span v-if="isLoadingU" class="opt-badge opt-badge--gray">
            <i class="fas fa-spinner fa-spin me-1"></i>Generando...
          </span>
          <span v-else class="opt-badge opt-badge--green">Excel</span>
          <i class="fas fa-chevron-right opt-card__arrow"></i>
        </div>
      </div>

      <!-- Exportar Propiedades -->
      <div class="opt-card" :class="{ 'opt-card--loading': isLoadingP }" @click="storeExportAllProperty">
        <div class="opt-card__icon" style="background:linear-gradient(135deg,#D97706,#F59E0B)">
          <i class="fas fa-home"></i>
        </div>
        <div class="opt-card__body">
          <p class="opt-card__title">Exportar Propiedades</p>
          <p class="opt-card__desc">Exportar todos los inmuebles con su respectivo agente asignado</p>
        </div>
        <div class="opt-card__action">
          <span v-if="isLoadingP" class="opt-badge opt-badge--gray">
            <i class="fas fa-spinner fa-spin me-1"></i>Generando...
          </span>
          <span v-else class="opt-badge opt-badge--amber">Excel</span>
          <i class="fas fa-chevron-right opt-card__arrow"></i>
        </div>
      </div>

    </div>

    <!-- Section: Importaciones -->
    <p class="section-label">Importaciones</p>
    <div class="options-grid">

      <!-- Importar Barrios -->
      <div class="opt-card" @click="runModalBarrios">
        <div class="opt-card__icon" style="background:linear-gradient(135deg,#7C3AED,#8B5CF6)">
          <i class="fas fa-map-marked-alt"></i>
        </div>
        <div class="opt-card__body">
          <p class="opt-card__title">Importar Barrios</p>
          <p class="opt-card__desc">Importa barrios desde un archivo Excel seleccionando país, departamento y ciudad</p>
        </div>
        <div class="opt-card__action">
          <span class="opt-badge opt-badge--purple">Excel</span>
          <i class="fas fa-chevron-right opt-card__arrow"></i>
        </div>
      </div>

    </div>

    <!-- Modal Domus -->
    <SoftModal v-if="modalDomus" @close="toggleModal" :modalActive="modalDomus" size="lg">
      <template #header>
        <div style="display:flex;align-items:center;gap:10px">
          <div style="width:32px;height:32px;border-radius:8px;background:linear-gradient(135deg,#1E3A5F,#2563EB);display:flex;align-items:center;justify-content:center;color:#fff;font-size:.85rem">
            <i class="fas fa-building"></i>
          </div>
          <span>Importar desde Domus</span>
        </div>
      </template>
      <formDomus />
    </SoftModal>

    <!-- Modal Wasi -->
    <SoftModal v-if="modalWasi" @close="modalWasi = false" :modalActive="modalWasi" size="md">
      <template #header>
        <div style="display:flex;align-items:center;gap:10px">
          <div style="width:32px;height:32px;border-radius:8px;background:linear-gradient(135deg,#B91C1C,#EF4444);display:flex;align-items:center;justify-content:center;color:#fff;font-size:.85rem">
            <i class="fas fa-plug"></i>
          </div>
          <span>Integración con Wasi</span>
        </div>
      </template>
      <formWasi />
    </SoftModal>

    <!-- Modal Apperty -->
    <SoftModal v-if="modalApperty" @close="modalApperty = false" :modalActive="modalApperty" size="lg">
      <template #header>
        <div style="display:flex;align-items:center;gap:10px">
          <div style="width:32px;height:32px;border-radius:8px;background:linear-gradient(135deg,#0F766E,#14B8A6);display:flex;align-items:center;justify-content:center;color:#fff;font-size:.85rem">
            <i class="fas fa-exchange-alt"></i>
          </div>
          <span>Integración con Apperty</span>
        </div>
      </template>
      <formApperty />
    </SoftModal>

    <!-- Modal Importar Barrios -->
    <SoftModal v-if="modalBarrios" @close="modalBarrios = false" :modalActive="modalBarrios" size="lg">
      <template #header>
        <div style="display:flex;align-items:center;gap:10px">
          <div style="width:32px;height:32px;border-radius:8px;background:linear-gradient(135deg,#7C3AED,#8B5CF6);display:flex;align-items:center;justify-content:center;color:#fff;font-size:.85rem">
            <i class="fas fa-map-marked-alt"></i>
          </div>
          <span>Importar Barrios Portales</span>
        </div>
      </template>

      <form @submit.prevent="handleImportBarrios">
        <div class="row g-3">
          <div class="col-md-6">
            <label class="form-label">País</label>
            <VSelect :options="countries" v-model="selectedCountry" label="name"
              :reduce="c => c.id" placeholder="Elige un país" />
          </div>
          <div class="col-md-6">
            <label class="form-label">Departamento</label>
            <VSelect :options="states" v-model="selectedDepId" label="name"
              :reduce="d => d.id" placeholder="Elige un departamento" />
          </div>
          <div class="col-md-6">
            <label class="form-label">Ciudad</label>
            <VSelect :options="cities" v-model="selectedCityId" label="name"
              :reduce="c => c.id" placeholder="Elige una ciudad" />
          </div>
          <div class="col-md-6">
            <label class="form-label">Zona</label>
            <VSelect :options="zones" v-model="selectedZones" label="name"
              :reduce="z => z.id" placeholder="Elige una zona" />
          </div>
          <div class="col-12">
            <label class="form-label">Archivo Excel</label>
            <input type="file" class="form-control form-control-sm"
              accept=".xlsx,.xls" @change="onFileChange" required />
          </div>
        </div>

        <div class="d-flex justify-content-end gap-2 mt-4">
          <SoftButton type="button" color="secondary" variant="outline" size="sm" @click="modalBarrios = false">
            Cancelar
          </SoftButton>
          <SoftButton type="submit" color="primary" variant="gradient" size="sm"
            :disabled="!selectedCityId || !selectedFile" :loading="isLoadingPo">
            <i class="fas fa-upload me-1"></i> Importar
          </SoftButton>
        </div>
      </form>
    </SoftModal>

  </div>
</template>

<script>
import { ref, watch } from 'vue'
import { useStore } from 'vuex'
import SoftButton from '@/components/SoftButton.vue'
import SoftModal from '@/components/SoftModal.vue'
import CrmPageHeader from '@/components/CrmPageHeader.vue'
import formDomus from './components/formDomus.vue'
import formWasi from './components/formWasi.vue'
import formApperty from './components/formApperty.vue'
import { useMembership } from '@/views/memberships/useMembership.js'

export default {
  name: 'OptionsView',
  components: { SoftButton, SoftModal, CrmPageHeader, formDomus, formWasi, formApperty },
  setup() {
    const store = useStore()
    const { countries, states, cities, zones, getHelpers, getStates, getCities, getZones } = useMembership()
    getHelpers()

    const isLoadingM  = ref(false)
    const isLoadingU  = ref(false)
    const isLoadingP  = ref(false)
    const isLoadingPo = ref(false)

    const modalDomus   = ref(false)
    const modalBarrios = ref(false)
    const modalWasi    = ref(false)
    const modalApperty = ref(false)

    const selectedCountry = ref(48)
    const selectedDepId   = ref(null)
    const selectedCityId  = ref(null)
    const selectedZones   = ref(null)
    const selectedFile    = ref(null)

    const watchVal = (src, cb) => watch(src, (v) => { if (typeof v !== 'object' && v) cb(v) })
    watchVal(selectedCountry, getStates)
    watchVal(selectedDepId,   getCities)
    watchVal(selectedCityId,  getZones)

    const runModalDomu    = () => { modalDomus.value = true }
    const runModalBarrios = () => { modalBarrios.value = true }
    const runModalWasi    = () => { modalWasi.value = true }
    const runModalApperty = () => { modalApperty.value = true }
    const toggleModal     = () => { modalDomus.value = false }
    const onFileChange    = (e) => { selectedFile.value = e.target.files[0] }

    const handleImportBarrios = async () => {
      if (!selectedFile.value || !selectedCityId.value) return
      isLoadingPo.value = true
      const fd = new FormData()
      fd.append('file', selectedFile.value)
      fd.append('city_id', selectedCityId.value)
      if (selectedZones.value) fd.append('zone_id', selectedZones.value)
      await store.dispatch('appHelpers/storeBarriosPortales', fd)
        .then(res => {
          alert(res.data.message || 'Barrios importados correctamente')
          modalBarrios.value = false
          selectedFile.value = null; selectedCityId.value = null
          selectedDepId.value = null; selectedZones.value = null
        })
        .catch(err => console.error(err))
        .finally(() => { isLoadingPo.value = false })
    }

    const runAgentMetrocucadrado = async () => {
      isLoadingM.value = true
      await store.dispatch('appHelpers/storeRunAgentMetrocuadrado')
        .catch(e => console.error(e)).finally(() => { isLoadingM.value = false })
    }

    const exportUsersMembership = async () => {
      isLoadingU.value = true
      await store.dispatch('appHelpers/storeExportUsersMemberships')
        .catch(e => console.error(e)).finally(() => { isLoadingU.value = false })
    }

    const storeExportAllProperty = async () => {
      isLoadingP.value = true
      await store.dispatch('appHelpers/storeExportAllProperty')
        .catch(e => console.error(e)).finally(() => { isLoadingP.value = false })
    }

    return {
      isLoadingM, isLoadingU, isLoadingP, isLoadingPo,
      countries, states, cities, zones,
      selectedCountry, selectedDepId, selectedCityId, selectedZones, selectedFile,
      modalDomus, modalBarrios, modalWasi, modalApperty,
      runModalDomu, toggleModal, runModalBarrios, runModalWasi, runModalApperty,
      runAgentMetrocucadrado, exportUsersMembership, storeExportAllProperty,
      handleImportBarrios, onFileChange,
    }
  },
}
</script>

<style scoped>
/* Section label */
.section-label {
  font-size: 0.68rem;
  font-weight: 700;
  letter-spacing: 0.1em;
  text-transform: uppercase;
  color: #94A3B8;
  margin: 0 0 12px;
}

/* Grid */
.options-grid {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(340px, 1fr));
  gap: 14px;
}

/* Card */
.opt-card {
  display: flex;
  align-items: center;
  gap: 16px;
  background: #fff;
  border: 1px solid #E2E8F0;
  border-radius: 14px;
  padding: 18px 20px;
  cursor: pointer;
  transition: all 0.18s ease;
  box-shadow: 0 1px 3px rgba(0,0,0,0.04);
  user-select: none;
}

.opt-card:hover {
  border-color: #BFDBFE;
  box-shadow: 0 4px 16px rgba(37,99,235,0.1);
  transform: translateY(-2px);
}

.opt-card--loading {
  pointer-events: none;
  opacity: 0.75;
}

/* Icon */
.opt-card__icon {
  width: 48px;
  height: 48px;
  min-width: 48px;
  border-radius: 12px;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #fff;
  font-size: 1.1rem;
  box-shadow: 0 4px 12px rgba(0,0,0,0.15);
}

/* Body */
.opt-card__body {
  flex: 1;
  min-width: 0;
}

.opt-card__title {
  font-size: 0.88rem;
  font-weight: 600;
  color: #1E293B;
  margin: 0 0 3px;
}

.opt-card__desc {
  font-size: 0.75rem;
  color: #64748B;
  margin: 0;
  line-height: 1.4;
}

/* Action */
.opt-card__action {
  display: flex;
  align-items: center;
  gap: 8px;
  flex-shrink: 0;
}

.opt-card__arrow {
  font-size: 0.65rem;
  color: #CBD5E1;
  transition: transform 0.15s ease, color 0.15s ease;
}

.opt-card:hover .opt-card__arrow {
  color: #2563EB;
  transform: translateX(3px);
}

/* Badges */
.opt-badge {
  display: inline-flex;
  align-items: center;
  font-size: 0.68rem;
  font-weight: 600;
  padding: 3px 10px;
  border-radius: 20px;
  white-space: nowrap;
}

.opt-badge--blue   { background: #EFF6FF; color: #2563EB; }
.opt-badge--sky    { background: #E0F2FE; color: #0284C7; }
.opt-badge--green  { background: #ECFDF5; color: #059669; }
.opt-badge--amber  { background: #FFFBEB; color: #D97706; }
.opt-badge--purple { background: #F5F3FF; color: #7C3AED; }
.opt-badge--gray   { background: #F1F5F9; color: #64748B; }
.opt-badge--red    { background: #FEF2F2; color: #DC2626; }
.opt-badge--teal   { background: #F0FDFA; color: #0F766E; }
</style>
